if (!customElements.get('download-popup')) {
  class DownloadPopup extends HTMLElement {
    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    handleToggle(event) {
      if (event.detail.id != this.getAttribute('data-id')) retur;

      this.classList.toggle('is-open');
      toggleLock(this.classList.contains('is-open'), this);
    }

    disconnectedCallback() {
      document.removeEventListener(
        'exo:toggle-download-popup',
        this.handleToggleRef,
      );
    }

    connectedCallback() {
      document.addEventListener(
        'exo:toggle-download-popup',
        this.handleToggleRef,
      );
    }
  }
  customElements.define('download-popup', DownloadPopup);
}
